import React from "react";
import { useSelector } from "react-redux";
import { Table } from "antd";
import dayjs from "dayjs";

function ShipmentDetails() {
  const editField = useSelector((state) => state.shipment.ui.clone.editField);

  const dataSource = [
    {
      key: "1",
      id: "id1",
      shipmentName: editField?.shipmentName?.value,
      startDateAndTime: editField?.startDate?.value ? dayjs(editField.startDate.value).format("DD-MM-YY [at] HH:mm:ss").toLowerCase(): null,
      state: editField?.state?.value,
    },
  ];

  const columns = [
    {
      title: <span className="font-face-vzw">Shipment Name</span>,
      dataIndex: "shipmentName",
      key: "shipmentName",
    },
    {
      title: <span className="font-face-vzw">Start Date and Time</span>,
      dataIndex: "startDateAndTime",
      key: "startDateAndTime",
    },
    {
      title: <span className="font-face-vzw">State</span>,
      dataIndex: "state",
      key: "state",
    },
  ];
  return (
    <>
      <div
        className="font-face-vzw py-1"
        style={{
          fontWeight: 700,
          fontSize: "20px",
          color: "#6F7171",
        }}
      >
        Shipment details
      </div>
      <Table dataSource={dataSource} columns={columns} pagination={false} />
    </>
  );
}

export default ShipmentDetails;
